import React from 'react';
import { Breadcrumb, Card } from 'antd';
import {
  Link,
  useParams,
  Switch,
  Route,
  useLocation,
  useHistory,
} from 'react-router-dom';
import { PageContainer } from '@ant-design/pro-layout';
import { useQuery } from '@apollo/client';
import { GET_PROJECT_CATEGORIES } from '../../../gql/projectCategories';
import TabBasic from './TabBasic';
import TabRoleHierarchy from './TabRoleHierarchy';
import TabReportSettings from './TabReportSettings';
import TabRoles from './TabRoles';
import TabRolesAdd from './TabRolesAdd';
import TabRolesEdit from './TabRolesEdit';
import TabApprovalRoutes from './TabApprovalRoutes';

const tabListNoTitle = [
  {
    key: 'basic',
    tab: 'basic',
  },
  {
    key: 'role-hierarchy',
    tab: 'role hierarchy',
  },
  {
    key: 'report-settings',
    tab: 'report settings',
  },
  {
    key: 'roles',
    tab: 'roles',
  },
  {
    key: 'approval-routes',
    tab: 'approval routes',
  },
  // {
  //   key: 'teamMembers',
  //   tab: 'team members',
  // },
];

const routes = [
  {
    path: 'basic',
    component: TabBasic,
  },
  {
    path: 'role-hierarchy/:type',
    component: TabRoleHierarchy,
  },
  {
    path: 'report-settings',
    component: TabReportSettings,
  },
  {
    path: 'roles',
    component: TabRoles,
  },
  {
    path: 'roles/add',
    component: TabRolesAdd,
  },
  {
    path: 'roles/:overriddenScopeId',
    component: TabRolesEdit,
  },
  {
    path: 'approval-routes',
    component: TabApprovalRoutes,
  },
  // teamMembers: {
  //   component: <p>teamMembers content</p>,
  //   description:
  //     'To override the access right of team member type in the project category',
  // },
];

const EditProjectCategory = () => {
  const { id } = useParams();
  const { pathname } = useLocation();
  const history = useHistory();
  const { data, loading } = useQuery(GET_PROJECT_CATEGORIES, {
    variables: { ids: [id], state: 'ALL' },
  });

  if (loading) {
    return (
      <PageContainer
        header={{
          title: 'Edit Project Category',
        }}
        loading
      />
    );
  }

  const projectCategory = data.projectCategories[0];
  const currentPath = pathname.split('/')[4];

  return (
    <PageContainer
      header={{
        title: `Edit Project Category - ${projectCategory.name}`,
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/project-categories">
                Project Categories
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{projectCategory.name}</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
    >
      <Card
        style={{ width: '100%' }}
        tabList={tabListNoTitle}
        activeTabKey={currentPath}
        onTabChange={(key) => {
          if (key === 'role-hierarchy') {
            return history.push(
              `/system-setting/project-categories/${id}/${key}/department`
            );
          }
          history.push(`/system-setting/project-categories/${id}/${key}`);
        }}
      >
        <Switch>
          {routes.map(({ path, component }) => (
            <Route
              exact
              path={`/system-setting/project-categories/:id/${path}`}
              component={component}
              key={path}
            />
          ))}
        </Switch>
      </Card>
    </PageContainer>
  );
};

export default EditProjectCategory;
